import { Typography, Button } from "@mui/material";
import { forwardRef, useImperativeHandle } from "react";
import { StepProps, StepRef } from "../types";
import StaticStep from "../components/StaticStep";
import { FAQ } from "../components/FAQ";
import useIsMobile from "components/hooks/useIsMobile";

export default forwardRef<StepRef, StepProps>(({ onNext }: StepProps, ref) => {
  useImperativeHandle(ref, () => ({}));
  const isMobile = useIsMobile();

  return (
    <StaticStep
      title="You deserve a trusted right hand"
      img="/assets/images/nux/Advisors2x.jpg"
      mobileImg="/assets/images/nux/AboutAdvisors-mobile.png"
      fullImageHeight={true}
      bodyContent={
        <>
          <Typography variant="body">
            We’ll match you with one dedicated Advisor — someone who truly gets
            to know you and your family. We accept fewer than 5% of applicants,
            and every Advisor is background-checked and trusted by families
            across the country.
          </Typography>

          <FAQ
            question="Can I trust my Advisor with sensitive info?"
            answer="Yes. You’ll have access to a private, encrypted space to share
                  confidential information securely with your Advisor. We never
                  store this information in plain text. Even in the unlikely
                  event of a full database breach, this info remains protected
                  and inaccessible without live authorization from a secondary
                  secured system."
          />
        </>
      }
      actions={
        <Button
          variant="contained"
          color="primary"
          size={isMobile ? "medium" : "large"}
          onClick={() => {
            onNext?.({ interruptTasks: true, interruptAboutAdvisors: true });
          }}
          sx={{
            width: isMobile ? "100%" : "auto",
          }}
        >
          Sounds great!
        </Button>
      }
    />
  );
});
